const AUTOPAY_PREAUTH_AMOUNT_DEFAULT = 2.01;
const AUTOPAY_PREAUTH_AMOUNT_ZERO = 0;

export function getAutopayPreauthAmount(isPreauthZeroEnabled: boolean): number {
  if (isPreauthZeroEnabled) {
    return AUTOPAY_PREAUTH_AMOUNT_ZERO;
  }
  return AUTOPAY_PREAUTH_AMOUNT_DEFAULT;
}
